import React,{useState} from 'react'
import BackgroundImage from '../../../../images/public/3.jpg'
import LoginLogo from '../../../../images/logos/iconwhite.png'
import Publicinput from './input'
import Publicbutton from '../../../../components/forms/publicbutton'
import './index.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import Functions from '../funtions'
import { Link } from 'react-router-dom'
import Facebook from '../facebook'
import Google from '../google'

const Index = () => {
    const [username,setUsername] = useState('')
    const [password,setPassword] = useState('')
    const [passShow, setPassShow] = useState(false);
  return (
    <div className='v2_web_public_login_wrapper' style={{backgroundImage:`url(${BackgroundImage})`}}>
        <div className='v2_web_public_login_overlay'>
            <div className='v2_web_public_login_container'>
                <div className='v2_web_public_login_logo_container'>
                    <div className='v2_web_public_login_logo_image'>
                        <img src={LoginLogo} alt='login_logo'/>
                    </div>
                    <h2>The easy way</h2>
                </div>
                <div className='v2_web_public_login_form'>
                    <h4>Log in</h4>
                    <Publicinput Lable={'Username'} Placeholder={'Enter username'} Type={'text'} Value={username} setValue={setUsername}/>
                    <Publicinput Lable={'Password'} Placeholder={'Enter password'} Type={passShow ? 'text' : 'password'} Value={password} setValue={setPassword} Icon={passShow ? <FontAwesomeIcon onClick={()=>{setPassShow(!passShow)}} icon={faEye}/> : <FontAwesomeIcon onClick={()=>{setPassShow(!passShow)}} icon={faEyeSlash}/>}/>
                    <Publicbutton Value={'Log in'} Action ={()=>{
                        Functions.post_login({
                            username: username,
                            password: password
                        });
                    }}/>
                    <div className='v2_web_public_login_form_fpsu'>
                        <Link to={'#'}><p className='v2_web_public_login_form_fp'>Forgot password?</p></Link>
                        <Link to={'/signup'}><p className='v2_web_public_login_form_su'>Signup</p></Link>
                    </div>
                    <div className='v2_web_public_login_form_or'>
                        <p>or</p>
                    </div>
                    <div className='v2_web_public_login_form_social'>
                        <Facebook/>
                        <Google/>
                    </div>
                </div>
                <div className='v2_web_public_login_aftertext'>
                    <h3>A platform where you can Buy-sell-Re sell or do it all over</h3>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Index
